export class VW_AUCTIONS {
    constructor(
        public AUCTION_ID: number,
        public AUCTION_NAME: string,
        public OPEN_DATE: Date,
        public CLOSE_DATE: Date,
        public SETTLE_DATE: Date,
        public CD_AUCTION_TYPE: string,
        public AUCTION_STAT : string
    ) { }
}

export class AUCTIONS {
    constructor(
        public AUCTION_ID: number,
        public AUCTION_NAME: string,
        public OPEN_DATE: Date,
        public CLOSE_DATE: Date,
        public SETTLE_DATE: Date,
        public EXTRA_DATE: Date,
        public SOPEN_DATE: string,
        public SCLOSE_DATE: string,
        public SSETTLE_DATE: string,
        public SEXTRA_DATE: string,        
        public CD_AUCTION_TYPE: string,
        public CREATED_BY: number
    ) { }
}


// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/models/auctions.ts